import { CustomTrace, SumKeyOperand } from 'src/Libs/chart-kit/shared/utils/chartModel'

interface UpdateTraceWithSumKeysParams {
  traceAlternateKey: string
  keys: string[]
  operand: SumKeyOperand
}

export const updateTraceWithSumKeys = (trace: CustomTrace, { traceAlternateKey, keys, operand }: UpdateTraceWithSumKeysParams): CustomTrace => {
  if (trace.alternateKey !== traceAlternateKey) return trace

  const existingSumKeys = trace.sumKeys?.filter(sumKey => sumKey.operand !== operand) ?? []
  const updatedSumKeys = keys.map(key => ({ operand, key }))

  return {
    ...trace,
    sumKeys: [...existingSumKeys, ...updatedSumKeys],
  }
}
